// import setAuthToken from "../../helpers/setAuthToken";
import axios from "axios";
import { URL } from "../../config/config";
import { expandPermissionSchema } from "../../helpers/accessControlHelper";

export const initialState = {
  isLoading: false,
  isAuthenticated: false,
  // isAuthenticated: true,
  user: {},
  error: null,
  errmsg: "",
  permissions: null,
};

export const START_LOGIN = "Login/START_LOGIN";
export const LOGIN_SUCCESS = "Login/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "Login/LOGIN_FAILURE";
export const RESET_ERROR = "Login/RESET_ERROR";
export const LOGIN_USER = "Login/LOGIN_USER";
export const SIGN_OUT_SUCCESS = "Login/SIGN_OUT_SUCCESS";
export const SET_PERMISSIONS = "Login/SET_PERMISSIONS";

export const startLogin = () => ({
  type: START_LOGIN,
});

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

export const loginFailure = (payload) => ({
  type: LOGIN_FAILURE,
  payload: payload,
});

export const resetError = (payload) => ({
  type: RESET_ERROR,
  payload: payload,
});

export const loginWithToken = (session) => async (dispatch) => {
  localStorage.setItem("session", session);
  const decoded = JSON.parse(atob(session));
  localStorage.setItem(
    "permissions",
    JSON.stringify(expandPermissionSchema(decoded.permissions))
  );
  dispatch(setPermissions(expandPermissionSchema(decoded.permissions)));
  dispatch(loginSuccess(decoded));
};

export const loginUser = (email, password) => (dispatch) => {
  dispatch(startLogin());
  dispatch(resetError());

  if (!!email && !!password) {
    const user = {
      email,
      password,
    };
    axios
      .post(URL + "/superadmin/login", user)
      .then(async (res) => {
        const { session } = res.data;
        localStorage.setItem("session", session);
        const decoded = JSON.parse(atob(session));
        localStorage.setItem(
          "permissions",
          JSON.stringify(expandPermissionSchema(decoded.permissions))
        );
        dispatch(setPermissions(expandPermissionSchema(decoded.permissions)));
        dispatch(loginSuccess(decoded));
      })
      .catch((err) => {
        console.error(err);
        dispatch(loginFailure({ errmsg: "Unable to setup connection" }));
      });
  } else {
    dispatch(loginFailure({ errmsg: "fields cant be empty" }));
  }
};

export const signOutSuccess = () => ({
  type: SIGN_OUT_SUCCESS,
});

export const signOut = (_id) => (dispatch) => {
  localStorage.removeItem("session");
  localStorage.removeItem("permissions");
  axios.post(URL + "/auth/logOut", { _id }).then((response) => {
    // console.log(response.data);
  });
  dispatch(signOutSuccess());

  window.location.reload();
};

export const modifyUser = (session) => (dispatch) => {
  const decoded = JSON.parse(atob(session));
  dispatch(loginSuccess(decoded));
};

export const setPermissionsFromLocalStorage = (_id) => async (dispatch) => {
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions"));
    if (!permissions?.length) {
      dispatch(signOut(_id));
      return;
    }
    dispatch(setPermissions(permissions));
  } catch (err) {
    dispatch(signOut(_id));
  }
};

export const setPermissions = (permissions) => ({
  type: SET_PERMISSIONS,
  payload: permissions,
});

export default function LoginReducer(state = initialState, { type, payload }) {
  switch (type) {
    case START_LOGIN:
      return {
        ...state,
        isLoading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        error: null,
        user: { ...payload },
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
        errmsg: payload.errmsg,
      };
    case RESET_ERROR:
      return {
        ...state,
        error: false,
      };
    case SIGN_OUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
      };
    case SET_PERMISSIONS:
      return {
        ...state,
        permissions: payload,
      };
    default:
      return state;
  }
}
